import './TriggerFileChanges';
import Paths from './lib/constants/paths';

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

const main = async function() {

  try {
    const rs = await loadScript(Paths.PublicPath + 'api/clientConfig');
    // console.log(rs);
  }
  catch (err){
    console.error('Failed to load clientConfig', err);
  }

  const { default: mainApp } = await import('./mainApp');
  mainApp();
}

main();
